var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-slate-100 min-h-screen"},[_c('div',[_c('router-view')],1)]),_c('FloatingNavbarMenu')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }